import { useForm } from 'react-hook-form'

import { FormCommand } from '@types'

export type AddCommandsDialog = {
  onCloseDialog: () => void
  onChangeCommands: (value?: FormCommand[] | null) => void
  commands?: FormCommand[] | null
}

export const useAddCommandsDialog = (props: AddCommandsDialog) => {
  const { commands, onCloseDialog, onChangeCommands } = props

  const methods = useForm<{ commands: FormCommand[] | null }>({
    defaultValues: {
      commands,
    },
  })

  const { trigger, getValues } = methods

  const handleSave = () => {
    trigger().then(value => {
      if (value) {
        const { commands } = getValues()

        onChangeCommands(commands)
        onCloseDialog()
      }
    })
  }

  return {
    data: {},
    state: {
      methods,
    },
    handlers: {
      handleSave,
    },
  }
}
